// Market chip colour - ANZ/USA market grouping used by the admin ROM/FBC & Region lists.
// Distinct from countryChips.ts, which styles the AU/NZ/US country axis.
import type { ChipProps } from '@mui/material'

export const getMarketChipColor = (market: string): ChipProps['color'] => {
  switch (market) {
    case 'ANZ':
      return 'primary'
    case 'USA':
      return 'secondary'
    default:
      return 'default'
  }
}
